<template>
  <div class="t-app__container">
    <heading :overTitle="$t('gathering-admin-dashboard-overTitle')" :title="$t('gathering-admin-dashboard-title')" :text="$t('gathering-admin-dashboard-text')" />
    <div class="h-section h-section--small-top">
      <admin-dashboard-tabs />
      <dashboard-section :title="$t('dashboard-admin-gathering-waiting-title')" toggleable :toggleableCount="gatheringsNotAuthorized.length">
        <gathering-authorization-list v-if="gatheringsNotAuthorized.length > 0" :value="gatheringsNotAuthorized" @updatedGathering="updateGatherings" />
        <span v-else>{{ $t('dashboard-admin-gathering-waiting-empty-title') }}</span>
      </dashboard-section>
      <dashboard-section :title="$t('dashboard-admin-gathering-authorized-title')" toggleable :toggleableCount="gatheringsAuthorized.length">
        <gathering-authorization-list v-if="gatheringsAuthorized.length > 0" :value="gatheringsAuthorized" @updatedGathering="updateGatherings" disableAuthorizationSelects />
        <span v-else>{{ $t('dashboard-admin-gathering-authorized-empty-title') }}</span>
      </dashboard-section>
      <dashboard-section :title="$t('dashboard-admin-gathering-refused-title')" toggleable :toggleableCount="gatheringsRefused.length">
        <gathering-authorization-list v-if="gatheringsRefused.length > 0" :value="gatheringsRefused" @updatedGathering="updateGatherings" />
        <span v-else>{{ $t('dashboard-admin-gathering-refused-empty-title') }}</span>
      </dashboard-section>
      <dashboard-section :title="$t('dashboard-admin-gathering-cancelled-title')" toggleable :toggleableCount="gatheringsCancelled.length">
        <gathering-authorization-list v-if="gatheringsCancelled.length > 0" :value="gatheringsCancelled" @updatedGathering="updateGatherings" disableAuthorizationSelects />
        <span v-else>{{ $t('dashboard-admin-gathering-cancelled-empty-title') }}</span>
      </dashboard-section>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/heading'
import AdminDashboardTabs from '@/components/dashboard/admin-dashboard-tabs'
import DashboardSection from '@/components/dashboard/dashboard-section'
import GatheringAuthorizationList from '@/components/dashboard/gathering/gathering-authorization-list'

import LoaderService from '@/services/loader'
import GatheringService from '@/services/gathering'

export default {
  components: {
    Heading,
    AdminDashboardTabs,
    DashboardSection,
    GatheringAuthorizationList
  },
  data() {
    return {
      gatherings: []
    }
  },
  computed: {
    gatheringsNotAuthorized: function() {
      return this.gatherings.filter(x => !x.IsPublish && x.IsSubmitted && !x.IsRefused)
    },
    gatheringsAuthorized: function() {
      return this.gatherings.filter(x => x.IsPublish && !x.IsCancelled)
    },
    gatheringsCancelled: function() {
      return this.gatherings.filter(x => x.IsPublish && x.IsCancelled)
    },
    gatheringsRefused: function() {
      return this.gatherings.filter(x => x.IsRefused && !x.IsCancelled)
    }
  },
  async beforeRouteEnter(to, from, next) {
    LoaderService.showLoader()
    let gatherings = await GatheringService.getAllAdminGathering()

    LoaderService.hideLoader()

    next(vm => {
      vm.gatherings = gatherings
    })
  },
  methods: {
    getGatherings: async function() {
      return await GatheringService.getAllAdminGathering()
    },
    updateGatherings: async function() {
      this.gatherings = await this.getGatherings()
    }
  }
}
</script>
